import config from "../config/environment";

const GO_BACKEND_URL = config.GO_BACKEND_URL;

function getAuthHeaders() {
  const token = sessionStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const alertService = {
  async getPowerEvents() {
    const response = await fetch(`${GO_BACKEND_URL}/power-events`);
    if (!response.ok) {
      throw new Error(`Unable to load power events (${response.status})`);
    }
    return response.json();
  },

  async deleteAllPowerEvents() {
    const response = await fetch(`${GO_BACKEND_URL}/power-events`, {
      method: "DELETE",
      headers: { ...getAuthHeaders() },
    });
    if (!response.ok) {
      throw new Error(`Unable to delete power events (${response.status})`);
    }
    return response.json();
  },
};

export default alertService;
